<!--  -->
<template>
  <div>
    <CpBanner
      :src="temData.imageTextItemList[0].imageUrl"
      :bgColor="temData.imageTextItemList[0].backgroundColor"
    />
    <!-- <CpHeadBanner
      :src="temData.imageTextItemList[0].imageUrl"
    /> -->
  </div>

</template>

<script>
import { mapState } from 'vuex';


export default {
  components: {
    
  },
  props: {
    temData: {
      type: Object
    }
  },
  computed:
    mapState({
      routes: state => state.router.routeList,
    })
}
</script>
